/***********new breadcrumb start******************/
$(document).ready(function () {
    var lastUrl = document.referrer;

    var lastUrl_segment_str = lastUrl; // return segment1/segment2/segment3/segment4

    var lastUrl_segment_array = lastUrl_segment_str.split('/');

    var lastUrl_Menu = '';
    if (($.inArray("products", lastUrl_segment_array) == -1) && ($.inArray("cart", lastUrl_segment_array) == -1) && ($.inArray("account", lastUrl_segment_array) == -1)) {
        lastUrl_Menu = lastUrl_segment_array.pop();
        var last_menu = lastUrl_Menu.split('?')[0];

    }


    var segment_str = window.location.pathname; // return segment1/segment2/segment3/segment4
    var segment_array = segment_str.split('/');
    var currentMenu = segment_array.pop();
    //document.write(last_segment);

    var html = '<span property="itemListElement" typeof="ListItem" class="first-list"><a href="/">Home</a></span>';

    if (lastUrl_Menu != '') {

        last_menu = last_menu.replace('-', ' ');
        last_menu = last_menu.replace('-', ' ');
        last_menu = last_menu.replace(/-/g, ' ');

        last_menu = last_menu.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        console.log('last_menu');
        console.log(last_menu);
        if (last_menu.indexOf('+') != -1) {
            last_menu = '';
        }
		
		if(last_menu != ''){
			last_menu = last_menu.replace('-', ' ');
            if (last_menu === '3for2 Kidswear') {
              last_menu = last_menu.replace('3for2', '3 For 2');
            }
			//last_menu = last_menu.toUpperCase();
			html += '&nbsp &nbsp &gt; &nbsp &nbsp<span property="itemListElement" typeof="ListItem"><a href="' + lastUrl + '">' + last_menu + '</a></span>';	
		}
        
    }
    //   console.log(currentMenu);
    if (segment_str != '') {
        console.log(segment_str);
        currentMenu = currentMenu.replace('-', ' ');
        currentMenu = currentMenu.replace('-', ' ');
        currentMenu = currentMenu.replace(/-/g, ' ');

        currentMenu = currentMenu.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        //console.log(currentMenu);
		var currenMenuCheck = currentMenu;
        currentMenu = currentMenu.toLowerCase();
		
		if (currentMenu.indexOf('/+') != -1) {
            currentMenu = segment_str.replace(currentMenu, '');
        }
        
        currentMenu = currentMenu.replace('/collections/', '');
		
		if (currentMenu.indexOf('/+') != -1) {
            var currentMenuData = currentMenu.split('/+');
			currentMenu = currentMenuData[0];
        }
		
		if (currentMenu.indexOf('+') != -1) {
            currentMenuData = currentMenu.split('+');
			currentMenu = currentMenuData[0];
        }
		
		currentMenu = currentMenu.replace('-', ' ');
        
        // console.log(currentMenu);

        if (currentMenu === '3for2 kidswear') {
          currentMenu = currentMenu.replace('3for2', '3 for 2');
        }
		
		// if(currentMenu == ''){
			// currentMenu = currenMenuCheck;
		// }
		if(currentMenu != ''){
			html += '&nbsp &nbsp &gt; &nbsp &nbsp<span property="itemListElement" typeof="ListItem" class="last-list"><span class="no-cursor" style="color: #000;font-weight: 400;">' + currentMenu + '</span></span>';	
		}
        
    }




    $('.breadcrumbs-custom-content').after(html);
    //   $('.breadcrumbs-custom-content span:last-child a').removeAttr('href');

    //alert(referrer);
});